import './App.css';
import Router from "./routes";
// import ProjectPage from './page/project';
function App() {
  return (
    <>
    {" "}
    <Router />{" "}
    </>
  
  );
}

export default App;
